<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-sm" (click)="compOffConsumeRequest()"
                [disabled]="isDisabled">
                <i class="bi bi-suitcase" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Consume Request':'Loading...'}}
            </button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-2 p-0">
    <div class="card-header">
        <div class="card-title">
            Compensatoryoff Consume Request History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="FromDate" class="text-label-dark">From Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                            [(ngModel)]="Filter.FromDate" ngbDatepicker #FromDate="ngbDatepicker"
                            [disabled]="Filter.IsWithdraw" readonly required (ngModelChange)="Clear()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button" [disabled]="Filter.IsWithdraw"></button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDate" class="text-label-dark">To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Filter.ToDate"
                            ngbDatepicker #ToDate="ngbDatepicker" [disabled]="Filter.IsWithdraw" readonly required (ngModelChange)="Clear()"/>
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button" [disabled]="Filter.IsWithdraw"></button>
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required [disabled]="Filter.IsWithdraw" (change)="Clear()">
                        @for (status of common.Status; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select status!
                    </div>
                </div>
                <div class="col" style="align-content: center;font-weight: 500;font-size: 15px;">
                    <span class="Label" style="margin-left: 3%;">
                        <input type="checkbox" name="admincharg" [(ngModel)]="Filter.IsWithdraw" ngbCheckbox
                            (change)="Clear()" />
                        Withdraw Only
                    </span>
                </div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">View</th>
                        <th style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Withdraw</th>

                        <th style="width: 600px; display: none;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Branch
                        </th>
                        <th style="width: 600px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">
                            Client Location</th>
                        <th style="width: 50px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">Designation</th>
                        <!-- <th style="width: 800px;text-overflow: ellipsis;white-space: nowrap;" [ngClass]="{'colHide': !this.Filter.IsWithdraw}">Client Location</th> -->
                        <th style="width: 50px;">RequestDate</th>
                        <th style="width: 50px;">FromDate</th>
                        <th style="width: 50px;text-overflow: ellipsis;white-space: nowrap;">ToDate</th>
                        <th style="width: 10px;">HalfDay</th>
                        <th style="width: 50px;">HalfSession</th>
                        <th style="width: 10px;">NoOfDay</th>
                        <th style="width: 50px;">Reason</th>
                        <th [ngClass]="{'colHide': this.Filter.IsWithdraw}">Status</th>
                        <!-- <th [ngClass]="{'colHide': !this.Filter.IsWithdraw}">Requester Name</th> -->
                        <th [ngClass]="{'colHide': !this.Filter.IsWithdraw}">Withdraw Date</th>
                        <!-- <th [ngClass]="{'colHide': !this.Filter.IsWithdraw}">Withdrawer Name</th> -->

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 70px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="openCompoffConsumeDetails(TableData['TransactionId'])"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 5px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 110px;"
                                *ngIf="common.ToLowerCase(TableData['ApprovalStatus']) == 'pending' || common.ToLowerCase(TableData['ApprovalStatus']) == 'approved'"><button
                                    type="button" class="btn btn-outline-primary btn-sm"
                                    (click)="SaveEmployeeCompOffDetails(i)"><i
                                        class="bi bi-x-circle me-1"></i>Withdraw</button></div>
                        </td>
                        <td style="width: 600px; display: none;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            <div style="width: 200px;">{{TableData['BranchName']}}</div>
                        </td>
                        <td style="width: 600px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">
                            <div style="width: 200px;">{{TableData['ClientLocation']}}</div>
                        </td>
                        <!-- | date : 'dd MMM yyyy HH:mm' -->
                        <td style="width: 50px;" [ngClass]="{'colHide': this.Filter.IsWithdraw}">
                            {{TableData['DesignationName']}}</td>
                        <!-- <td style="width: 800px;" [ngClass]="{'colHide': !this.Filter.IsWithdraw}">{{TableData['ClientLocation']}}</td> -->
                        <td style="width: 50px;">{{TableData['RequestDate'] | date : 'dd MMM yyyy' }}</td>
                        <td style="width: 50px;">{{TableData['LeaveFromDate'] }}</td>
                        <td style="width: 50px;text-overflow: ellipsis;white-space: nowrap;">{{TableData['LeaveToDate']
                            }}</td>
                        <td style="width: 10px;">{{TableData['HalfDay']?'Yes':'No'}}</td>
                        <td style="width: 50px;">{{TableData['HalfDaySession']}}</td>
                        <td style="width: 10px;">{{TableData['NoOfDay']}}</td>
                        <td style="width: 50px;">{{TableData['Reason']}}</td>
                        <td [ngClass]="{'colHide': this.Filter.IsWithdraw}"><span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
                        </td>
                        <!-- <td [ngClass]="{'colHide': !this.Filter.IsWithdraw}">{{TableData['RequesterName']}}</td> -->
                        <td [ngClass]="{'colHide': !this.Filter.IsWithdraw}">{{TableData['WithdrawDate']}}</td>
                        <!-- <td [ngClass]="{'colHide': !this.Filter.IsWithdraw}">{{TableData['WithdrawerName']}}</td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>